import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  id: 0,
  login: '',
  password: '',
  sender: '',
  errors: {
    errors: [],
    commonErrors: []
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit("FORM_RESET");
    systemSettingApi.getSmsSetting()
      .then(({ data }) => commit('SMS_SETTING_FETCHED', data))
      .catch(err => commit('SMS_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateSmsSetting(state)
      .then(({ data }) => commit('SMS_SETTING_UPDATED', data))
      .catch((error) => {
        commit('SMS_SETTING_UPDATE_FAILED', error.response.data)
        throw error;
      })
  },
  resetForm({ commit }) {
    commit("FORM_RESET")
  },
}

const mutations = {
  SMS_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  SMS_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  SMS_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
